import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import Moment from 'react-moment';
import Duration from './Duration';


const getAlertBadge = alert => {
  switch (alert.alertStatus) {
    case 'RESOLVED':
      return <Badge color="success">Resolved</Badge>;
    case 'CLAIMED':
      return <Badge color="warning">Claimed</Badge>;
    case 'CONFIRMED':
      return <Badge color="info">Confirmed</Badge>;
    default:
      return <Badge color="danger">Unclaimed</Badge>;
  }
};

const Alert = ({ alert, showName, showRoom }) => (
  <tr className="filter-row">
    {
      showName && (
        <td><strong>{alert.resident.name}</strong> {showRoom && <span className="text-muted font-italic ml-2" style={{ fontSize: '80%' }}>(room {alert.resident.roomNumber})</span>}</td>
      )
    }
    <td>
      <h5 className="mb-0 float-left">
        {
          getAlertBadge(alert)
        }
      </h5>
    </td>
    <td>
      <div className="float-right">
        {
          alert.alertStatus === 'RESOLVED' ?
            <Moment format="MMM Do, YYYY [at] h:mma">{alert.createdAt}</Moment> :
            <Duration pad>{alert.createdAt}</Duration>
        }
      </div>
    </td>
  </tr>
);

Alert.propTypes = {
  alert: PropTypes.object.isRequired,
  showName: PropTypes.bool,
  showRoom: PropTypes.bool,
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/AlertRow.js